import { Content, Main, SubContent } from "../../../components/Layout";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import useWrapper from "../../../hooks/useWrapper";
import ModalFinancialReceipt from "../../../components/Modal/modal-financial-receipt";
import { traineeFinancial } from "../../../hooks/api/listFinancial";
import { toast } from "react-toastify";
import { Row, Col } from "react-bootstrap";
import TraineeSubMenu from "../../../components/Submenu/TraineeSubMenu";
import Button from "../../../components/Button";
import Loading from "../../../components/Loading";
import SlipsTable from "../../../components/SlipsTable";
import useFormat from "../../../hooks/utils/useFormat";
import api from "../../../services/api";

export default function TraineesFinancial() {
  const { me, config } = useWrapper();
  const { trainee, setisWaitingResponse } = useOutletContext() || {};
  const { formatReal } = useFormat();

  const [reloadFinancial, setreloadFinancial] = useState();
  const reloadFinancialData = () => {
    setreloadFinancial(JSON.stringify(new Date()));
  };

  const [financial, setfinancial] = useState();
  const [totalGenerated, settotalGenerated] = useState();
  useEffect(() => {
    (async () => {
      try {
        setisLoadingSlips(true);
        const _financial = await traineeFinancial({
          config,
          me,
          trainee_id: trainee?.id,
          commercial_id: trainee?.commercial_id,
        });
        const _total_generated = await api.get(`/total-amount-generated-per-traineer/${trainee?.id}`, config);
        setfinancial(_financial);
        settotalGenerated(_total_generated.data);
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Problema ao carregar os pagamentos");
      } finally {
        setisLoadingSlips(false);
      }
    })();
  }, [reloadFinancial]);

  const [showModalFinancial, setshowModalFinancial] = useState();

  const [isLoadingSlips, setisLoadingSlips] = useState();
  useEffect(() => {
    setisWaitingResponse(isLoadingSlips);
  }, [isLoadingSlips]);

  const [isNewFinancial, setisNewFinancial] = useState();
  useEffect(() => {
    setisNewFinancial(!(financial?.payment_slips?.contracted?.length > 0));
  }, [financial?.payment_slips?.contracted?.length > 0]);

  const updateSlip = props => {
    const { slip_id, update } = props;
    setfinancial({
      ...financial,
      payment_slips: {
        ...financial?.payment_slips,
        contracted: financial?.payment_slips?.contracted?.map(__slip => {
          return __slip.id === slip_id
            ? {
                ...__slip,
                ...update,
              }
            : __slip;
        }),
      },
    });
  };

  const checkAllActives = value => {
    setfinancial({
      ...financial,
      payment_slips: {
        ...financial?.payment_slips,
        contracted: financial?.payment_slips?.contracted?.map(__slip => {
          return {
            ...__slip,
            ...(__slip?.status !== "Pago" && __slip?.status !== "Cancelado" ? { checked: value } : {}),
          };
        }),
      },
    });
  };

  return (
    <Row>
      <Col sm={9}>
        <Main>
          {!isLoadingSlips ? (
            <>
              {!isNewFinancial ? (
                <Content>
                  <Row>
                    <Col>
                      <h2 className="mini-title">
                        Pagamentos Ativos: <span className="small-label">(Financeiro Contratado)</span>
                      </h2>
                      <p className="small-label mb-2">
                        Boletos com vencimento em finais de semana e feriados poderão ser pagos no próximo dia útil sem
                        multas e taxas.
                      </p>
                    </Col>
                  </Row>
                  <SlipsTable
                    date_end={financial?.commercial?.date_end}
                    slips={financial?.payment_slips?.contracted
                      ?.filter(__payment => __payment.status !== "Cancelado")
                      ?.filter(__payment => __payment.status !== "Pago")}
                    updateSlip={__update => {
                      updateSlip({
                        slip_id: __update.slip_id,
                        update: __update.update,
                      });
                    }}
                    checkAllToogle={checkAllActives}
                    show_total={true}
                    reload={reloadFinancialData}
                    multi_edit={true}
                    trainee_due_date={trainee?.due_date}
                  />
                  <Row className="mt-4">
                    <Col>
                      <h2 className="mini-title">Pagamentos Efetuados:</h2>
                      <p className="small-label mb-2">
                        Histórico dos pagamentos realizados. Revise as transações para confirmar os valores quitados.
                      </p>
                    </Col>
                  </Row>
                  <SlipsTable
                    slips={financial?.payment_slips?.contracted?.filter(__payment => __payment.status === "Pago")}
                    paid_values={true}
                    show_total={true}
                  />
                  <div>
                    <Row className="mt-4">
                      <Col>
                        <h2 className="mini-title">
                          Pagamentos Cancelados com Juros: <span className="small-label">(Financeiro Contratado)</span>
                        </h2>
                        <p className="small-label mb-2">
                          Histórico dos pagamentos cancelados que possuem juros. Precisamos desses valores para calcular
                          multas e juros não pagos.
                        </p>
                      </Col>
                    </Row>
                    <SlipsTable
                      slips={financial?.payment_slips?.contracted?.filter(
                        __payment => __payment.status === "Cancelado",
                      )}
                      updateSlip={__update => {
                        updateSlip({
                          slip_id: __update.slip_id,
                          update: __update.update,
                        });
                      }}
                      is_cancel={true}
                      reload={reloadFinancialData}
                      show_total={true}
                    />
                  </div>
                </Content>
              ) : !trainee?.cancel ? (
                <Content>
                  <h2 className="mini-title">Criar Financeiro do Formando:</h2>
                  <p className="small-label mb-2 mt-1">
                    Esse formando não possui o seu financeiro criado. Clique no botão abaixo para criar sua primeira
                    negociação.
                  </p>
                  <Button
                    style={{ maxWidth: "200px" }}
                    color="primary"
                    onClick={() => {
                      setshowModalFinancial({
                        open: true,
                        first_financial: true,
                        transaction_config: {
                          type: "receita",
                          batch: false,
                        },
                        pre_load: {
                          trainee_ids: [trainee?.id],
                          commercial_id: trainee?.commercial_id,
                        },
                      });
                    }}
                    disabled={false}
                    data-vertical="true"
                  >
                    Criar Financeiro
                  </Button>
                </Content>
              ) : (
                <Content>
                  <p className="mb-0">Nenhum pagamento registrado e o vínculo com esse formando está Encerrado.</p>
                  <p className="mb-0">
                    Caso deseje criar o financeiro desse formando será necessário restaurar seu vínculo primeiro.
                  </p>
                </Content>
              )}
            </>
          ) : (
            <Content>
              <Loading />
            </Content>
          )}
        </Main>
      </Col>
      <Col sm={3}>
        <TraineeSubMenu trainee={trainee} />
        {!isNewFinancial && (
          <>
            {!trainee?.cancel && (
              <>
                <SubContent className="mt-3">
                  <h2 className="mini-title">Atualizar Negociação:</h2>
                  {Math.abs(totalGenerated?.diferenceToGenerate) > 0.5 && (
                    <p className="small-label mb-2 mt-1">
                      <b>Atenção:</b> Houve mudanças no financeiro desse formando no valor de{" "}
                      <b>{formatReal(totalGenerated?.diferenceToGenerate || 0)}</b>. Você poderá renegociar todo o
                      financeiro
                      {totalGenerated?.diferenceToGenerate > 0.5 ? " ou gerar a diferença para o financeiro atual" : ""}
                      .
                    </p>
                  )}
                  <div className="divisor mt-3 mb-3"></div>
                  <Button
                    color="warning"
                    onClick={() => {
                      setshowModalFinancial({
                        open: true,
                        transaction_config: {
                          type: "receita",
                          batch: false,
                        },
                        pre_load: {
                          trainee_ids: [trainee?.id],
                          commercial_id: trainee?.commercial_id,
                        },
                      });
                    }}
                    disabled={false}
                    data-vertical="true"
                  >
                    Renegociar Financeiro
                  </Button>
                  <p className="small-label mb-2 mt-1">
                    <b>Atenção:</b> Todos os pagamentos ativos e não pagos serão cancelados para que a nova negociação
                    seja efetuada. Os valores de multas e juros serão passados para essa nova negociação.{" "}
                    <u>
                      Os valores de descontos e taxas da <b>negociação</b> não serão mantidos.
                    </u>
                  </p>
                  {totalGenerated?.diferenceToGenerate > 0.5 && (
                    <>
                      <div className="divisor mt-3 mb-3"></div>
                      <Button
                        color="warning"
                        onClick={() => {
                          setshowModalFinancial({
                            open: true,
                            transaction_config: {
                              type: "gerar-diferenca",
                              batch: false,
                            },
                            pre_load: {
                              trainee_ids: [trainee?.id],
                              commercial_id: trainee?.commercial_id,
                              value: totalGenerated?.diferenceToGenerate,
                            },
                          });
                        }}
                        disabled={false}
                        data-vertical="true"
                      >
                        Gerar Diferença
                      </Button>
                      <p className="small-label mb-2 mt-1">
                        <b>Atenção:</b> A diferença será adicionada ao financeiro atual. Sem interferência nos
                        pagamentos já negociados anteriormente.
                      </p>
                    </>
                  )}
                </SubContent>
              </>
            )}
            <SubContent className="mt-3">
              <h2 className="mini-title">Contratados:</h2>
              <p className="small-label mb-2 mt-1">
                Resumo do acordo contratado. Qualquer alteração nos contratados exigirá uma renegociação financeira.
              </p>
              <div className="divisor mt-3 mb-3"></div>
              {!!financial?.package && (
                <>
                  <p className="m-0">Pacote {financial?.package?.name}</p>
                  {financial?.package?.events?.map(__event => (
                    <p className="small-label m-0">
                      <b>{__event.name}</b>
                    </p>
                  ))}
                  <p className="small-label m-0">{formatReal(financial?.package?.value_per_trainee_original || 0)}</p>
                </>
              )}
              {!!financial?.singles?.length > 0 && (
                <>
                  <p className="m-0 mt-2">Avulsos</p>
                  {financial?.singles?.map(__single => (
                    <p className="small-label m-0">
                      <b>{__single?.event?.name}:</b> {formatReal(__single?.value_per_trainee_original || 0)}
                    </p>
                  ))}
                </>
              )}

              <p className="m-0 mt-2">Itens Adicionais</p>
              {financial?.aditional_items?.filter(__item => __item.payer_type === "item_adicional")?.length > 0 ? (
                <>
                  {financial?.aditional_items
                    ?.filter(__item => __item.payer_type === "item_adicional")
                    ?.map(__item => (
                      <p className="small-label m-0">
                        <b>
                          {__item?.quantity} {__item.name}:
                        </b>{" "}
                        {formatReal(__item?.cost)}
                      </p>
                    ))}
                </>
              ) : (
                <p className="small-label m-0">{formatReal(0)}</p>
              )}

              <p className="m-0 mt-2">Bônus e Promoções</p>
              {financial?.discounts?.length > 0 ? (
                <>
                  {financial?.discounts?.map(__discount => (
                    <p className="small-label m-0">
                      <b>{__discount.description}:</b> {formatReal(__discount?.value || 0)}
                    </p>
                  ))}
                </>
              ) : (
                <p className="small-label m-0">{formatReal(0)}</p>
              )}

              <p className="m-0 mt-2">Res. Aportes e Retiradas</p>
              <p className="small-label m-0">
                {financial?.values_calc?.contracted?.contributions_benefits <= 0 ? "" : "- "}
                {formatReal(Math.abs(financial?.values_calc?.contracted?.contributions_benefits))}
              </p>

              <p className="m-0 mt-2">Multas e Juros (Atrasos)</p>
              <p className="small-label m-0">{formatReal(financial?.values_calc?.contracted?.slips_fines_fees)}</p>

              <p className="m-0 mt-2">Desconto (Negociação)</p>
              <p className="small-label m-0">{formatReal(financial?.values_calc?.contracted?.slips_discounts)}</p>

              <p className="m-0 mt-2">Taxas (Negociação)</p>
              <p className="small-label m-0">{formatReal(financial?.values_calc?.contracted?.slips_taxes || 0)}</p>
            </SubContent>
          </>
        )}
      </Col>
      <ModalFinancialReceipt
        show={showModalFinancial?.open}
        onHide={() => {
          setshowModalFinancial();
        }}
        transaction_config={showModalFinancial?.transaction_config}
        pre_load={showModalFinancial?.pre_load}
        refreshCallback={() => {
          reloadFinancialData();
        }}
      />
    </Row>
  );
}
